<template>
  <div id="pageItemList">
    <page-header :title="$t('sparePartReport')"></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text>
              <v-form ref="editCreateForm">
                <v-container grid-list-md fluid>
                  <v-layout wrap justify-space-between>
                    <v-flex md4>
                      <v-autocomplete
                        name="vehicles"
                        :label="$t('vehicle')"
                        :loading="vehicleIsLoading"
                        :items="vehicles"
                        :search-input.sync="vehicleSearch"
                        v-model="reportParams.vehicle"
                        cache-items
                        clearable
                        prepend-icon="train"
                        item-text="name"
                        item-value="id"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md4>
                      <v-autocomplete
                        name="spare_part_type"
                        :label="$t('sparePartType')"
                        :loading="sparePartTypeIsLoading"
                        :items="sparePartTypes"
                        :search-input.sync="sparePartTypeSearch"
                        v-model="reportParams.sparePartType"
                        cache-items
                        item-text="name"
                        item-value="id"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md4>
                      <v-checkbox
                        v-model="reportParams.includeReplaced"
                        :label="$t('includeReplacedSpareParts')"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :href="getDownloadUrl" target="_blank" color="success">
                {{ $t("download") }}
                <v-icon right>save_alt</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import {
  FETCH_VEHICLES,
  RESET_REPORT,
  FETCH_SPARE_PART_TYPES
} from "@/store/actions.type";
import JwtService from "../../common/jwt.service";
import store from "@/store";

export default {
  data() {
    return {
      vehicleSearch: "",
      sparePartTypeSearch: "",
      reportParams: {
        vehicle: null,
        sparePartType: null,
        includeReplaced: false
      },
      LANG: process.env.VUE_APP_LANG
    };
  },
  computed: {
    ...mapGetters([
      "vehicles",
      "vehicleIsLoading",
      "sparePartTypes",
      "sparePartTypeIsLoading"
    ]),
    getDownloadUrl() {
      return (
        process.env.VUE_APP_API_URL +
        "/report/spare-part/file?" +
        (this.reportParams.vehicle
          ? "&vehicle=" + this.reportParams.vehicle
          : "") +
        (this.reportParams.sparePartType
          ? "&sparePartType=" + this.reportParams.sparePartType
          : "") +
        "&includeReplaced=" +
        this.reportParams.includeReplaced +
        "&bearer=" +
        JwtService.getToken()
      );
    }
  },
  watch: {
    vehicleSearch: _.debounce(function(val) {
      this.$store.dispatch(FETCH_VEHICLES, [{ rowsPerPage: -1 }, val]);
    }, 300),
    sparePartTypeSearch: _.debounce(function(val) {
      this.$store.dispatch(FETCH_SPARE_PART_TYPES, [{ rowsPerPage: -1 }, val]);
    }, 300)
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(RESET_REPORT)]).then(() => {
      next();
    });
  }
};
</script>

<style scoped></style>
